import { render } from "./PickGallery.vue?vue&type=template&id=ea99b8c4"
import script from "./PickGallery.vue?vue&type=script&lang=js"
export * from "./PickGallery.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__